/**
 * @generated SignedSource<<682e8ce309f3935523dd01b3f806077d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LinkHubspotDealInput = {
  projectId?: string | null;
  dealId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type LinkHubspotDealMutation$variables = {
  input: LinkHubspotDealInput;
};
export type LinkHubspotDealMutation$data = {
  readonly linkHubspotDeal: {
    readonly project: {
      readonly hubspotDeal: string | null;
    } | null;
  } | null;
};
export type LinkHubspotDealMutation = {
  variables: LinkHubspotDealMutation$variables;
  response: LinkHubspotDealMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hubspotDeal",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LinkHubspotDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LinkHubspotDealPayload",
        "kind": "LinkedField",
        "name": "linkHubspotDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LinkHubspotDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LinkHubspotDealPayload",
        "kind": "LinkedField",
        "name": "linkHubspotDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a3a72691c2a0e32f20802cfa1c170fa5",
    "id": null,
    "metadata": {},
    "name": "LinkHubspotDealMutation",
    "operationKind": "mutation",
    "text": "mutation LinkHubspotDealMutation(\n  $input: LinkHubspotDealInput!\n) {\n  linkHubspotDeal(input: $input) {\n    project {\n      hubspotDeal\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f8134445a87b33e93c547fdb1f978a6";

export default node;
